import React, { FC } from "react";

import Image from "next/image";

import { Actions } from "@/components/common/table/actions";
import { Category } from "../../get-parcels-table/components";

import { renderCountryImage } from "@/utils/iconRenderer";

import { ParcelCategoryUZ } from "@/enums";
import {
  AddIcon,
  InsuranceIcon,
  SignatureIcon,
  UpsIcon,
} from "@/components/assets/icons";

type TProps = {
  parcelId: number | null;
};

const ViewSentParcel: FC<TProps> = ({ parcelId }) => {
  // TODO get correct parcel data
  // const currentParcel = DUMMY_SEND_PARCELS_DATA.orderCreated.find(
  //   (parcel) => parcel.id === parcelId,
  // );

  const currentParcel = null;

  return (
    <div className="w-[33.5rem] pb-10">
      {/* <PaymentRequired /> */}
      <ul>
        {/* {parcelDetails?.map(({ label, value }) => (
          <li
            key={label}
            className="flex items-center justify-between border-b py-5"
          >
            <p className="text-sm font-semibold text-black">{label}</p>
            {value}
          </li>
        ))} */}

        <li className="flex items-center justify-between border-b py-5">
          <p className="text-sm font-semibold text-black">ID Number</p>
          <p className="text-[#808080]">{currentParcel?.id}</p>
        </li>

        <li className="flex items-center justify-between border-b py-5">
          <p className="text-sm font-semibold text-black">Substatus</p>
          <p className="text-[#008000]">PROCESSED</p>
        </li>

        <li className="flex items-center justify-between border-b py-5">
          <p className="text-sm font-semibold text-black">Sent to</p>
          <div className="flex items-center gap-5">
            <div className="h-8 w-8">
              <Image
                src={renderCountryImage[currentParcel?.country]}
                width={100}
                height={100}
                alt="country-image"
              />
            </div>
            <p className="text-medium uppercase text-black">
              {currentParcel.country}
            </p>
          </div>
        </li>

        <li className="flex items-center justify-start gap-[10px] border-b py-5">
          {/* @ts-ignore */}
          <Category category={currentParcel?.category as ParcelCategoryUZ} />
          <div className="flex flex-col">
            <p className="text-sm font-semibold text-black">Category</p>
            <p className="text-sm font-medium text-[#808080]">
              Clothes, Shoes, Brand new
            </p>
          </div>
        </li>

        <li className="flex items-center justify-between border-b py-5">
          <p className="text-sm font-semibold text-black">Value</p>
          <p className="text-[#808080]">${currentParcel?.value}</p>
        </li>

        <li className="py-5">
          <h2 className="text-sm font-medium uppercase text-[#adadad]">
            personal information
          </h2>
          <ul>
            {/* {sendParcelDetails.personalInformation?.map(({ label, value }) => (
              <li
                key={label}
                className="flex items-center justify-between border-b py-5"
              >
                <p className="text-sm font-semibold text-black">{label}</p>
                <p className="text-sm font-medium text-[#808080]">{value}</p>
              </li>
            ))} */}
          </ul>
        </li>
        <li className="py-5">
          <h2 className="text-sm font-medium uppercase text-[#adadad]">
            receiver information
          </h2>
          <ul>
            {/* {sendParcelDetails.receiverInformation?.map(({ label, value }) => (
              <li
                key={label}
                className="flex items-center justify-between border-b py-5"
              >
                <p className="text-sm font-semibold text-black">{label}</p>
                <p className="text-sm font-medium text-[#808080]">{value}</p>
              </li>
            ))} */}
          </ul>
        </li>
        <li className="border-b pb-5">
          <h2 className="text-sm font-medium uppercase text-[#b2b2b2]">
            Shipping option
          </h2>
          <div className="mt-[14px] flex items-center justify-between">
            <p className="text-sm font-semibold text-black">Delivery company</p>
            <div className="flex items-center">
              <UpsIcon />
              <p className="text-sm font-medium text-black"> USPS</p>
            </div>
          </div>
        </li>
      </ul>
      <div className="mt-7">
        <div className="flex w-full items-center justify-between">
          <h2 className="text-sm font-medium uppercase text-[#b2b2b2]">
            Additional Services
          </h2>
          <div className="primary-bg flex h-8 w-8 cursor-pointer items-center justify-center rounded-full p-1">
            <AddIcon className="h-5 w-5 fill-white" />
          </div>
        </div>
        <div className="mt-7 flex w-full items-center justify-between gap-[10px]">
          <div className="flex justify-between gap-[10px]">
            <div className="secondary-bg h-[2.87rem] w-[2.87rem] rounded-full p-2">
              <InsuranceIcon className="primary-color" />
            </div>
            <div className="flex flex-col">
              <h2 className="text-sm font-semibold text-black">Insurance</h2>
              <p className="text-sm font-normal text-[#808080]">3.5 %</p>
            </div>
          </div>
          <Actions onDelete={() => {}} />
        </div>

        <div className="mt-7 flex w-full items-center justify-between gap-[10px]">
          <div className="flex justify-between gap-[10px]">
            <div className="secondary-bg h-[2.87rem] w-[2.87rem] rounded-full p-2">
              <SignatureIcon className="primary-color" />
            </div>
            <div className="flex flex-col">
              <h2 className="text-sm font-semibold text-black">
                Shipping form signature
              </h2>
              <p className="text-sm font-normal text-[#808080]">3.5 %</p>
            </div>
          </div>
          <Actions onDelete={() => {}} />
        </div>
      </div>
    </div>
  );
};

export default ViewSentParcel;
